import React from 'react';
import PropTypes from 'prop-types';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteDialog from '@tenant/core/App/Dialog/DeleteDialog';
import useDeleteContainerApp from 'redux/slices/containerApp/hooks/useDeleteContainerApp';
import { Button, DialogContentText } from '@mui/material';
import useModal from '@tenant/utility/hooks/useModal';

const DeleteContainerApp = ({
  isShowTrigger = true,
  trigger,
  visible,
  onClose,
  containerName,
  appInstanceId,
  containerAppId,
  callbackAfterSuccess = () => {},
}) => {
  const deleteAction = useDeleteContainerApp({
    callbackAfterSuccess: () => {
      callbackAfterSuccess();
      handleClose();
    },
  });
  const {
    visible: visibleLocal,
    onShow: onShowLocal,
    onClose: onCloseLocal,
  } = useModal();

  const handleClose = () => {
    if (typeof onClose === 'function') {
      onClose();
      return;
    }

    onCloseLocal();
  };
  return (
    <>
      {trigger ??
        (isShowTrigger && (
          <Button
            startIcon={<DeleteIcon />}
            color='error'
            onClick={onShowLocal}
          >
            Delete
          </Button>
        ))}

      <DeleteDialog
        visible={visible ?? visibleLocal}
        action='Delete'
        loading={deleteAction.isPending}
        handleClose={handleClose}
        handleSave={() => {
          deleteAction.mutate({ appInstanceId, containerAppId });
        }}
      >
        <DialogContentText id='alert-delete-dialog-description'>
          Warning: This action cannot be undone. Are you sure you want to delete{' '}
          {containerName ?? 'container app'} ?
        </DialogContentText>
      </DeleteDialog>
    </>
  );
};

export default React.memo(DeleteContainerApp);

DeleteContainerApp.propTypes = {
  // Required props
  appInstanceId: PropTypes.string.isRequired,
  containerAppId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,

  // Optional props
  trigger: PropTypes.node,
  visible: PropTypes.bool,
  isShowTrigger: PropTypes.bool,
  onClose: PropTypes.func,
  containerName: PropTypes.string,
  callbackAfterSuccess: PropTypes.func,
};
